import axiosInstance from './axiosInstance';

const UserService = {
  getUsername: () => {
    return axiosInstance.get('/api/get-username/');
  },
};

export default UserService;
